import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";
import { HamburgerMenu } from "iconsax-reactjs";
import GlobalSearch from "../GlobalSearch";
import TeamTaskNotificationManager from "../dashboard/TeamTaskNotificationManager";
import DueTodayNotificationManager from "../dashboard/DueTodayNotificationManager";
import { useTheme } from "../../contexts/ThemeContext";

const Layout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const { isDarkMode } = useTheme();

  return (
    <div
      className={`flex h-screen overflow-hidden transition-colors duration-300 ${
        isDarkMode ? "bg-[#0C0E12]" : "bg-[#F4F5F7]"
      }`}
    >
      {/* Team Task Notification Manager - Shows flash notifications */}

      {/* Mobile/tablet sidebar */}
      <div
        className={`fixed inset-0 z-40 flex lg:hidden ${
          sidebarOpen ? "" : "hidden"
        }`}
      >
        <div
          className="fixed inset-0 bg-gray-600 bg-opacity-75"
          onClick={() => setSidebarOpen(false)}
        ></div>
        <div
          className={`relative flex flex-col max-w-xs ${
            isDarkMode ? "bg-[#0C0E12]" : "bg-white"
          }`}
        >
          <div className="absolute top-0 right-0 -mr-12 pt-2">
            <button
              className="ml-1 flex items-center justify-center h-10 w-10 rounded-full focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white"
              onClick={() => setSidebarOpen(false)}
            >
              <span className="sr-only">Close sidebar</span>
              <svg
                className="h-6 w-6 text-white"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                aria-hidden="true"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>
          <Sidebar />
        </div>
      </div>

      {/* Static sidebar for desktop */}
      <div className="hidden lg:flex lg:flex-shrink-0">
        <Sidebar />
      </div>

      {/* Main content */}
      <div className="flex flex-col flex-1 overflow-hidden">
        <div
          className={`relative z-10 flex-shrink-0 flex h-16 border-b lg:hidden transition-colors duration-300 ${
            isDarkMode
              ? "bg-[#0C0E12] border-[#22262F]"
              : "bg-white border-[#E2E4E9]"
          }`}
        >
          <button
            className="px-4 lg:hidden"
            onClick={() => setSidebarOpen(true)}
          >
            <span className="sr-only">Open sidebar</span>
            <HamburgerMenu
              className={isDarkMode ? "text-white" : "text-[#1A1D23]"}
            />
          </button>
        </div>

        <main className="flex-1 relative overflow-y-auto focus:outline-none">
          <TeamTaskNotificationManager />
          <DueTodayNotificationManager />
          {/* <GlobalSearch /> */}
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default Layout;
